import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Divider,
  LinearProgress,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import UpgradeDialog from "./UpgradeDialog";
import LimitDialog from "./LimitDialog";
import FeedbackDialog from "./FeedbackDialog";

const LessonLimitDialog = ({
  open,
  onClose,
  lessonCount,
  lessonLimit,
  lessonLimitExceeded,
  isDark,
  styles,
  user,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            maxWidth: "550px",
            width: "90%",
          },
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 4,
            top: 6,
            color: "text.secondary",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ padding: 5, paddingTop: 7 }}>
          <Typography variant="body1" sx={{ mt: 1, mb: 7, lineHeight: 1.6 }}>
            Du använder för närvarande ett <strong>gratiskonto</strong> vilket
            innebär en daglig begränsning på hur mycket du får generera.
            Uppgradera ditt konto för <strong>obegränsad användning</strong>.
          </Typography>

          <Box sx={{ mb: 3, mt: 4 }}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: "500", fontSize: "1rem" }}
              >
                Genereringar kvar:
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: "500", fontSize: "1rem" }}
              >
                {lessonLimit - lessonCount} / {lessonLimit}
              </Typography>
            </Box>

            <LinearProgress
              variant="determinate"
              value={((lessonLimit - lessonCount) / lessonLimit) * 100}
              sx={{
                height: 14,
                borderRadius: 4,
                backgroundColor: lessonLimitExceeded
                  ? "#ffcdd2"
                  : isDark
                    ? "#2a3b4c"
                    : "#e0e0e0",
                "& .MuiLinearProgress-bar": {
                  borderRadius: 4,
                  backgroundColor: lessonLimitExceeded
                    ? "#ff1744"
                    : isDark
                      ? "#14a561"
                      : "#14a561",
                },
              }}
            />
          </Box>

          <Box sx={{ mt: 7, mb: 2 }}>
            <Button
              onClick={() => {
                setIsDialogOpen(true);
              }}
              variant="purp"
              fullWidth
              startIcon={<RocketLaunchIcon />}
            >
              Uppgradera konto
            </Button>
          </Box>
          <Box
            sx={{
              textAlign: "center",
              mt: 0,
              color: "text.secondary",
              fontSize: "1rem",
            }}
          >
            Har du några frågor?{" "}
            <Box
              component="span"
              sx={{
                color: "primary.main",
                cursor: "pointer",
                fontSize: "1rem",
                fontWeight: 500,
                textDecoration: "none",
                display: "inline",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => setContactDialogOpen(true)}
            >
              Kontakta oss
            </Box>
          </Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ textAlign: "center", display: "none" }}
          >
            Uppgradera för obegränsad användning och fler funktioner
          </Typography>
        </DialogContent>
      </Dialog>
      <FeedbackDialog
        open={contactDialogOpen}
        onClose={() => setContactDialogOpen(false)}
        user={user}
        contactForm="true"
      />

      <LimitDialog
        open={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
        }}
        userId={user.uid}
        user={user}
        styles={styles}
        titleText="Uppgradera ditt konto"
      />
    </>
  );
};

export default LessonLimitDialog;
